export default __webpack_public_path__ + "static/media/BLR20.059421ff.jpg";